import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

import { ButtonPurpose } from './button-purpose';
import { ButtonType } from './button-type';

@Component({
  // Retain the shared selector so existing Reader templates migrate without markup churn.
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'button[mhe-button]',
  templateUrl: './button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.aria-checked]': 'ariaChecked()',
    '[attr.aria-expanded]': 'ariaExpanded()',
    '[attr.class]': 'buttonClasses()',
    '[attr.role]': 'role()',
    '[attr.type]': 'type()',
  },
})
export class ButtonComponent {
  readonly ariaExpanded = input<boolean | null>(null);
  readonly checked = input<boolean | null>(null);
  // Preserve the ngx-shared API so static and bound caller classes are retained during migration.
  // eslint-disable-next-line @angular-eslint/no-input-rename
  readonly customClass = input('', { alias: 'class' });
  readonly enableLight = input(false);
  readonly purpose = input<ButtonPurpose | `${ButtonPurpose}`>(ButtonPurpose.Primary);
  readonly type = input<ButtonType | `${ButtonType}`>(ButtonType.Button);

  protected readonly ariaChecked = computed(() => (
    typeof this.checked() === 'boolean' ? this.checked() : null
  ));

  protected readonly role = computed(() => (
    typeof this.checked() === 'boolean' ? 'switch' : null
  ));

  // Mirrors ngx-shared's class order; styling still comes from the global Open Learning theme.
  protected readonly buttonClasses = computed(() => [
    'btn',
    // The icon package uses :not(.ngx-shared) to swap hover assets to white.
    'ngx-shared',
    this.purpose(),
    this.enableLight() ? 'btn-secondary-light' : '',
    this.checked() ? 'active' : '',
    this.customClass(),
  ].filter(Boolean).join(' '));
}